import {getServerTexts as getTexts, initTexts, texts} from '../../../Localization/texts';

const entity = 'UI_NEWOTHER';

const en = {
    prev_record_tooltip: 'Previous record',
    next_record_tooltip: 'Next record',
    prev_page_tooltip: 'Previous page',
    next_page_tooltip: 'Next page',
    of_delimeter: 'of',
    many_label: 'many',
    record_label: 'Record',
    results: 'Results',
    total_results: 'Total results',
    many_tooltip: 'Click to calculate total results',
    export_to_excel_label: 'Export to Excel',
    export_to_excel_text: 'You can export your results to data sheet.',
    export_to_excel_title: '{count} results had founded.'
};

const he = {
    prev_record_tooltip: 'לרשומה הקודמת',
    next_record_tooltip: 'לרשומה הבאה',
    prev_page_tooltip: 'לדף הבא',
    next_page_tooltip: 'לדף הקודם',
    of_delimeter: 'מִתוֹך',
    many_label: 'רבים',
    record_label: 'רשומה',
    results: 'Results',
    total_results: 'סה”כ רשומות',
    many_tooltip: 'לחצו לחישוב מספר הרשומות',
    export_to_excel_label: 'Export to Excel',
    export_to_excel_text: 'You can export your results to data sheet.',
    export_to_excel_title: '{count} results had founded.'
};

const fallbacks = {
    en,
    he
};

export const mapping = {};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

initTexts(entity, fallbacks);

export default texts[entity];
